import Avatar from './Avatar'
import Badge from './Badge'
import Calendar from './Calendar'
import Card from './Card'
import CheckableTag from './CheckableTag'
import Collapse from './Collapse'
import CollapseItem from './CollapseItem'
import Comment from './Comment'
import ConfirmModal from './ConfirmModal'
import CustomCard from './CustomCard'
import CustomCollapse from './CustomCollapse'
import DeleteConfirmModal from './DeleteConfirmModal'
import Empty from './Empty'
import HorizontalLine from './HorizontalLine'
import Item from './Item'
import ItemWithoutSpacing from './ItemWithoutSpacing'
import Popover from './Popover'
import RowWithAction from './RowWithAction'
import TabPane from './TabPane'
import Table from './Table'
import Tabs from './Tabs'
import Tag from './Tag'
import Timeline from './Timeline'
import Tooltip from './Tooltip'
import ValidationSummary from './ValidationSummary'

export default {
  ConfirmModal,
  DeleteConfirmModal,
  Avatar,
  Badge,
  Calendar,
  Card,
  CheckableTag,
  Collapse,
  CollapseItem,
  Comment,
  CustomCard,
  CustomCollapse,
  Empty,
  HorizontalLine,
  Item,
  ItemWithoutSpacing,
  Popover,
  RowWithAction,
  Table,
  TabPane,
  Tabs,
  Tag,
  Timeline,
  Tooltip,
  ValidationSummary,
}
